import React from "react";
import { FaTimes } from "react-icons/fa";

const ActiveFilters = ({
  filters,
  searchTerm,
  onRemoveFilter,
  onClearAll,
  statusLabels = {},
  squadLabel,
}) => {
  const activeFilters = [];

  if (filters.status !== "on_squad") {
    activeFilters.push({
      type: "status",
      label: `Status: ${statusLabels[filters.status] || filters.status}`,
      value: filters.status,
    });
  }

  if (filters.event !== "all") {
    activeFilters.push({
      type: "event",
      label: `Event: ${filters.event}`,
      value: filters.event,
    });
  }

  if (filters.squad !== "all") {
    activeFilters.push({
      type: "squad",
      label: `Squad: ${squadLabel || filters.squad}`,
      value: filters.squad,
    });
  }

  if (searchTerm) {
    activeFilters.push({
      type: "search",
      label: `Search: "${searchTerm}"`,
      value: searchTerm,
    });
  }

  if (activeFilters.length === 0) {
    return null;
  }

  return (
    <div className="mb-4">
      <div className="flex items-center gap-2 mb-2">
        <span className="text-sm font-medium text-brand-charcoal">Filters</span>
        <button
          type="button"
          onClick={onClearAll}
          className="text-sm text-brand-gold-ink hover:underline font-medium"
        >
          Clear
        </button>
      </div>
      <div className="flex flex-wrap gap-2">
        {activeFilters.map((filter) => (
          <span
            key={`${filter.type}-${filter.value}`}
            className="inline-flex items-center gap-2 px-3 py-1 bg-brand-cream text-brand-charcoal rounded-full text-sm font-medium"
          >
            <span>{filter.label}</span>
            <button
              type="button"
              onClick={() => onRemoveFilter(filter.type)}
              className="hover:bg-brand-cream rounded-full p-1 transition-colors"
            >
              <FaTimes className="w-3 h-3" />
            </button>
          </span>
        ))}
      </div>
    </div>
  );
};

export default ActiveFilters;
